export interface RangeFilter {
    unit: string;
    convertTo?: string;
    group: 'group-dimensions' | 'group-price';
    component: 'range' | 'select' | 'discount-range';
}

export interface FilterConfiguration {
    enabledRangeFilters: {
        [key: string]: RangeFilter;
    };
    enabledAttributeFilters: string[];
}

export const getFilterConfiguration = (): FilterConfiguration => {
    return {
        enabledRangeFilters: {
            'price': {
                unit: 'currency',
                group: 'group-price',
                component: 'range',
            },
            'discount-filter': {
                unit: 'percentage',
                group: 'group-price',
                component: 'discount-range',
            },
            'range-filter-depth': {
                unit: 'mm',
                convertTo: 'cm',
                group: 'group-dimensions',
                component: 'range',
            },
            'range-filter-length': {
                unit: 'mm',
                convertTo: 'cm',
                group: 'group-dimensions',
                component: 'range',
            },
            'range-filter-height': {
                unit: 'mm',
                convertTo: 'cm',
                group: 'group-dimensions',
                component: 'range',
            },
            'range-filter-width': {
                unit: 'mm',
                convertTo: 'cm',
                group: 'group-dimensions',
                component: 'range',
            },
        },
        enabledAttributeFilters: [
            'country',
            'decade',
            'locations',
            'getty_image_rotation',
            'designer',
            'socket',
            'in_physical_store',
            'color_filter',
            'material',
            'material_prod',
            'material_filter',
        ],
    };
};
